import { enUS, ko } from 'date-fns/locale';

function getLocaleData(localesType) {
  switch (localesType) {
    case "ko": {
      return ko;
    }
    case "en": {
      return enUS;
    }
  }
}

export { getLocaleData as default };
//# sourceMappingURL=getLocaleData.mjs.map
